import { Amount } from '../CreateItinerary/CreateItineraryForm';

const calculateTotalWithVat = (amount: Amount) => {
  return (1 + amount.vat) * amount.amount;
};

const calculateVATAmount = (amount: Amount) => {
  return amount.vat * amount.amount;
};

const AmountUtils = {
  calculateTotalWithVat,
  calculateVATAmount,
};

export default AmountUtils;
